import { render, staticRenderFns } from "./ObservationOptions.vue?vue&type=template&id=1270ce0f"
import script from "./ObservationOptions.vue?vue&type=script&lang=js"
export * from "./ObservationOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports